import React from 'react';
import * as S from '../CostsBreakdown/styles';
import { Skeleton } from './styles';

const rows = Array.from({ length: 3 }, (_, i) => i);

const FeeGroupLoading = ({ section }: { section: string }) => (
  <>
    {rows.map((rowNum) => (
      <S.PriceRow key={`${section}-${rowNum}`}>
        <Skeleton width={200} height={20} />
        <Skeleton width={100} height={20} />
      </S.PriceRow>
    ))}
  </>
);

const FeeContainerSkeleton = ({ title }: { title: string }) => {
  return (
    <S.FeesContainerWrapper>
      <S.Title>{title}</S.Title>
      <S.FeesSection>
        <S.PriceGroup>
          <S.SectionTitle>Required</S.SectionTitle>
          <FeeGroupLoading section={`${title.toLowerCase().replace(/\s+/g, '-')}-required`} />
        </S.PriceGroup>
        <S.PriceGroup>
          <S.SectionTitle>Optional</S.SectionTitle>
          <FeeGroupLoading section={`${title.toLowerCase().replace(/\s+/g, '-')}-optional`} />
        </S.PriceGroup>
      </S.FeesSection>
      <S.Footer>
        <span>{title === 'Due monthly' ? 'Estimated monthly total' : 'Estimated total'}</span>
        <S.FooterPrice>
          <Skeleton width={100} height={24} />
        </S.FooterPrice>
      </S.Footer>
    </S.FeesContainerWrapper>
  );
};

export default function CostsSkeleton() {
  return (
    <>
      <FeeContainerSkeleton title="Due before you move in" />
      <div style={{ marginTop: '16px' }}>
        <FeeContainerSkeleton title="Due monthly" />
      </div>
    </>
  );
}
